module.exports = __webpack_public_path__ + "static/media/svcs.fb0e0128.jpg";